import { OnboardingVideo } from 'libs/onboarding/src/lib/onboarding-modal/steps/onboarding-step/onboarding-step.component';

export const siteSetupVideos: OnboardingVideo[] = [
  {
    title: 'site_setup_help_video1_title',
    description: 'site_setup_help_video1_description',
    thumbnailUrl: 'https://secure.ffd.ai/tutorials/install_flow/thumbnail-ffdsetup-overview.jpg',
    videoUrl: 'https://secure.ffd.ai/tutorials/install_flow/Overview_HD_Oct_18.mp4',
    fileType: 'video/mp4',
    loop: false,
  },
  {
    title: 'site_setup_help_video2_title',
    description: 'site_setup_help_video2_description',
    thumbnailUrl: 'https://secure.ffd.ai/tutorials/install_flow/thumbnail-ffdsetup-1.jpg',
    videoUrl: 'https://secure.ffd.ai/tutorials/install_flow/Licensing_HD_Oct_18.mp4',
    fileType: 'video/mp4',
    loop: false,
  },
  {
    title: 'site_setup_help_video3_title',
    description: 'site_setup_help_video3_description',
    thumbnailUrl: 'https://secure.ffd.ai/tutorials/install_flow/thumbnail-ffdsetup-2.jpg',
    videoUrl: 'https://secure.ffd.ai/tutorials/install_flow/Server_HD_Oct_18.mp4',
    fileType: 'video/mp4',
    loop: false,
  },
  {
    title: 'site_setup_help_video4_title',
    description: 'site_setup_help_video4_description',
    thumbnailUrl: 'https://secure.ffd.ai/tutorials/install_flow/thumbnail-ffdsetup-3.jpg',
    videoUrl: 'https://secure.ffd.ai/tutorials/install_flow/PracticeManager_HD_Oct_18.mp4',
    fileType: 'video/mp4',
    loop: false,
  },
];
